import React from "react";
import { Button as AntButton } from "antd";
import { cx } from "../../utils/classNames";

const variantToType = {
  primary: { type: "primary" },
  secondary: { type: "default" },
  ghost: { type: "text" },
  danger: { type: "primary", danger: true },
};

const sizeToAntd = {
  sm: "small",
  lg: "large",
};

export function Button({
  variant = "secondary",
  size,
  iconLeft,
  iconRight,
  className,
  children,
  type,
  loading = false,
  disabled,
  ...rest
}) {
  const variantProps = variantToType[variant] || variantToType.secondary;
  const antdSize = sizeToAntd[size];
  const classes = cx(
    "btn",
    variant && `btn-${variant}`,
    size && `btn-${size}`,
    className,
  );

  return (
    <AntButton
      {...variantProps}
      {...rest}
      htmlType={type}
      size={antdSize}
      icon={iconLeft}
      className={classes}
      loading={loading}
      disabled={disabled || loading}
    >
      {children}
      {iconRight && <span className="btn-icon-right">{iconRight}</span>}
    </AntButton>
  );
}

export default Button;
